import React from "react";
import Header from "../../../../ui-components/LandingPage/DashboardUi/Header";
import TestimonialOne from "../../../../ui-components/LandingPage/DashboardUi/TestimonialOne";
import TestimonialTwo from "../../../../ui-components/LandingPage/DashboardUi/TestimonialTwo";
import EmailFinder from "../../../../ui-components/LandingPage/DashboardUi/EmailFinder";
import Context from "../../../../ui-components/LandingPage/DashboardUi/Context";
import Slider from "../../../../ui-components/LandingPage/DashboardUi/Slider";
import Form from "../../../../ui-components/LandingPage/DashboardUi/Form";
import Zappier from "../../../../ui-components/LandingPage/DashboardUi/Zappier";
// import Banner from "../../../../ui-components/LandingPage/DashboardUi/Banner";
// import Content from "../../../../ui-components/LandingPage/DashboardUi/Content";
// import Sample from "../../../../ui-components/LandingPage/DashboardUi/Sample";

const Dashboard = () => {
  return (
    <>
      <div className="mb-8">
        <Header />
      </div>
      <div className="mb-8">
        <TestimonialOne />
      </div>
      <div className="mb-9">
        <TestimonialTwo />
      </div>
      <div className="mb-9">
        <Zappier />
      </div>
      <div className="mb-9">
        <EmailFinder />
      </div>
      <div className="mb-7">
        <Context />
      </div>
      <div className="mb-7">
        <Slider />
      </div>
        <Form />
      {/* <div className="mb-7">
        <Banner />
      </div> */}
      {/* <div className="mb-7">
        <Content />
      </div> */}
        {/* <Sample /> */}
    </>
  );
};

export default Dashboard;
